import { render } from "./RFIAttachments.vue?vue&type=template&id=6bf85af2&scoped=true"
import script from "./RFIAttachments.vue?vue&type=script&lang=js"
export * from "./RFIAttachments.vue?vue&type=script&lang=js"

import "./RFIAttachments.vue?vue&type=style&index=0&id=6bf85af2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf85af2"]])

export default __exports__